<template>
    <iframe v-if="selectPlugin != null" id="show-plugin" ref="iframeExternalPluginProperties" style="width:100%;height:93%;" frameBorder=0>
    </iframe>
</template>


<script>
import {mapMutations} from "vuex"
export default {
    data(){
      return{
        seletedPlugin:null
      }
    },
    methods:{
        selectPlugin(plugin){
          this.seletedPlugin = plugin
          
          this.loadExternalPluginPropertiesTopNavBar({id: this.pluginInfo.id,pluginName: this.seletedPlugin,tagId: "show-plugin"})// eslint-disable-line no-undef
          this.iframeController = this.$refs.iframeExternalPluginProperties.contentWindow
        },
        listenMessagesFromChild(){
          window.addEventListener('message', (event)=>{
            let cmd = event.data.cmd
            switch (cmd) {
              case 'readyToListenMessage':{
                  this.iframeController.postMessage({
                    cmd: 'fileinfo',
                    params: {
                      file_info:this.extraInfo
                    }
                    }, '*')
                  break;
                }
              default:
                break;
            }
          }
          )
        },
        ...mapMutations("registry",["loadExternalPluginPropertiesTopNavBar"]),
    },
    props:["pluginInfo","extraInfo"],
    created(){
      this.listenMessagesFromChild()
    },
    mounted() {
      setTimeout(() => this.selectPlugin(this.pluginInfo.pluginName), 100);
    },

}
</script>


<style lang="scss" scoped>
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue: #007bff;

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  font-size: 14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow: hidden;
}


body {
  background: $body-bg-color !important;
  color: $text-color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  height: 100%;
  font-size:14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow:hidden;
}

html{
  overflow: auto;
}

select option {
    margin: 40px;
    background: #000;
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
</style>


